// Every avatar we publish, served by filename from a stable URL that redirects to the
// media service. The image behind a filename can be replaced without touching the
// assistants that store it. Mirrors avatarURLs in ai-assistants; keep the two in sync.
const AVATAR_BASE_URL = 'https://ai-assistants-prod.apigateway.co/avatars/';

export const DEFAULT_AVATAR_URLS = {
  'ai-blogger.jpg': `${AVATAR_BASE_URL}ai-blogger.jpg`,
  'ai-content.jpg': `${AVATAR_BASE_URL}ai-content.jpg`,
  'ai-custom.png': `${AVATAR_BASE_URL}ai-custom.png`,
  'ai-receptionist.jpg': `${AVATAR_BASE_URL}ai-receptionist.jpg`,
  'ai-reputation.jpg': `${AVATAR_BASE_URL}ai-reputation.jpg`,
  'ai-sales-assistant.jpg': `${AVATAR_BASE_URL}ai-sales-assistant.jpg`,
  'ai-search.jpg': `${AVATAR_BASE_URL}ai-search.jpg`,
} as const;

export const LIBRARY_AVATARS: ReadonlyArray<{ filename: string; url: string }> = [
  'custom-image-library1.jpg',
  'custom-image-library2.jpg',
  'custom-image-library3.jpg',
  'custom-image-library4.jpg',
  'custom-image-library5.jpg',
  'custom-image-library6.jpg',
  'custom-image-library7.jpg',
  'custom-image-library8.jpg',
  'custom-image-library9.jpg',
  'custom-image-library10.jpg',
  'custom-image-library11.jpg',
  'custom-image-library12.jpg',
  'custom-image-library13.jpg',
  'custom-image-library14.jpg',
  'custom-image-library15.jpg',
  'custom-image-library16.jpg',
  'custom-image-library17.jpg',
  'custom-image-library18.jpg',
  'custom-image-library19.jpg',
  'custom-image-library20.jpg',
  'custom-image-library21.jpg',
  'custom-image-library22.jpg',
  'custom-image-library23.jpg',
  'custom-image-library24.jpg',
  'custom-image-library25.jpg',
  'custom-image-library26.jpg',
  'custom-image-library27.jpg',
  'custom-image-library28.jpg',
  'custom-image-library29.jpg',
  'custom-image-library30.jpg',
  'custom-image-library31.jpg',
  'custom-image-library32.jpg',
  'custom-image-library33.jpg',
  'custom-image-library34.jpg',
  'custom-image-library35.jpg',
].map((filename) => ({ filename, url: `${AVATAR_BASE_URL}${filename}` }));
